import React from 'react'
import Form from './container'
import PageTemplate from 'components/page-template'

export default () => (
  <PageTemplate
    title='Create a Facebook Recurring Reminder Experience'
    description="that's where automagic happens"
    className='br-experience widgetBuilder'
  >
    <Form
      experiencePlatform='facebook'
      experienceType='facebook_recurring_reminder'
    />
  </PageTemplate>
)



// WEBPACK FOOTER //
// ./src/pages/widgets/fb-recurring-reminder/create/index.js